/** Mga industry pack (M29): picker, preview, apply at mga label. Shell created by WP-M29-SCHEMA1: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const packs = {
  picker: {
    formatTwo: "Industry setup",
    formatTwoHint: "May kasamang pangalan ng customer context, mga kategorya, flow at rule, hindi lang mga label.",
  },
  preview: {
    contextTitle: "Mga pangalan ng customer context",
    contextHint: "Paano tinatawag ng Sagot ang mga field na ipinapadala ng inyong system.",
    contextTable: "Mga pangalan ng customer context",
    platformField: "Field ng platform",
    yourLabel: "Inyong tawag",
    values: "Mga halaga",
    contactField: "Contact field",
    noValues: "Itinatakda ng inyong system",
    addsTitle: "Ano ang idinadagdag ng pack na ito",
    addsHint: "Suriin muna, saka i-apply. Maaari ninyong baguhin ang lahat pagkatapos.",
    safetyTitle: "Mga safety preset",
    safetyHint: "Naka-lock na bukas sa pack na ito.",
    lockedRule: "Hindi maaaring patayin",
    outranksTiers: "Nauuna sa bawat tier",
    itemsCount_one: "{{count}} item",
    itemsCount_other: "{{count}} item",
    showSection: "Ipakita ang mga item ng {{section}}",
    mode: {
      copied: "Idinadagdag sa inyong workspace bilang sariling kopya. Maaari ninyo itong i-edit pagkatapos.",
      active: "Umiiral mula sa pack na ito at napapalitan kapag nag-apply kayo ng ibang pack.",
    },
    evalCases: "{{count}} test na tanong: {{en}} English, {{fil}} Filipino, {{taglish}} Taglish",
    deskSetup: "Setup ng service desk",
    sections: {
      customer_context: "Mga pangalan ng customer context",
      fields: "Mga field",
      categories: "Mga kategorya ng ticket",
      flows: "Mga guided flow",
      routing: "Routing at mga handover rule",
      knowledge_starters: "Mga knowledge starter",
      connector_templates: "Mga lookup",
      compliance_preset: "Mga safety preset",
      glossary: "Bokabularyo",
      eval_set: "Evaluation set",
    },
    pii: {
      none: "Hindi personal na datos",
      identifier: "Personal: identifier",
      contact: "Personal: contact",
      financial: "Personal: pinansyal",
      sensitive: "Personal: sensitibo",
    },
    meta: {
      priority: "Priyoridad",
      team: "Team",
      phrases: "Mga seed na parirala",
      trigger: "Trigger",
      steps: "Mga hakbang",
      object: "Object",
      type: "Uri",
      pii: "Personal na datos",
      pii_class: "Klase ng personal na datos",
      rank: "Ranggo",
      locale: "Wika",
      protected: "Hindi isinasalin",
      escalation: "Ipinapasa sa tao",
      urgent: "Madalian",
      locked: "Naka-lock",
      outranks_tiers: "Bago ang mga tier",
      helpline: "Helpline sa labas ng oras",
      urgent_ticket: "Urgent na ticket sa labas ng oras",
      on_call: "Alerto sa naka-on-call sa labas ng oras",
      first_response_minutes: "Unang sagot (min)",
      regulator_deadline_hours: "Deadline ng regulator (oras)",
      citations: "Mga pinagkunan",
      draft: "Draft",
      method: "Method",
      path: "Path",
      identity_bound: "Identity mula sa session",
      kinds: "Tinatakpan",
      days: "Araw na itinatago",
      action: "Aksyon",
      statuses: "Mga status",
      flags: "Mga flag",
    },
    emptyTitle: "Karaniwang setup lang ang idinadagdag ng pack na ito",
    emptyHint: "Wala itong sariling kategorya, flow o rule. I-apply ito para palitan ang mga tawag sa desk ayon sa inyong negosyo.",
  },
  apply: {
    doneV2: "Na-apply ang {{name}}: {{added}} ang naidagdag, {{kept}} ang iniwan kung ano sila.",
    refused: "{{count}} ang hindi nagawa. Nakasaad sa preview ang dahilan.",
  },
  labels: {
    english: "English",
    filipino: "Filipino",
    taglish: "Taglish",
  },
};
